<template>
  <div>
    <div class="font-semibold text-sm">
      The system builds your approval workflow based on your organization's
      hierarchy. Start by selecting the workflow type, single functional or
      multifunctional. You can restrict approvals to only certain users (by job
      level), remove certain users from the approval flow and set who are
      authorized signatories.
    </div>
    <div class="text-sm my-4">
      <div>Restrict approvers to selected job levels (optional):</div>
      <div class="flex flex-row justify-around my-3">
        <span
          :class="[{ checked: isChecked }, 'rounded job-level']"
          v-for="i in 6"
          :key="i"
        >
          <b-form-checkbox v-model="isChecked" :value="`job level ${7 - i}`">
            Job Level {{ 7 - i }}
          </b-form-checkbox>
        </span>
        <!--                  
                                        <check-box v-for="i in 6" :key="i" class=" rounded" :label="`Job Level ${7-i}`"></check-box> -->
      </div>
    </div>
    <div class="my-3">
      <div class="text-sm font-semibold my-3">
        Select Approving Functions and approvers:
      </div>
      <div class="text-sm">
        For the initiating function, approval will be in line with the reporting
        structure within the organization. You need to choose the approvers for
        the next approving functional domain, should it go beyond the initiating
        function.
      </div>
      <div class="text-xs font-bold my-3">Approval Starts:</div>
      <div>
        <div
          class="border bg-backgroundGrey2 rounded text-base"
          style="height: 40px; width: 260px; padding: 10px 15px 10px 15px"
        >
          Initiating Function
        </div>
        <div class="my-3 px-3">
          <img src="./partials/arrow-down.svg" alt="" />
        </div>
      </div>
    </div>
    <!-- Functional domain part -->
    <div v-for="(domain, i) in functionalDomain" :key="i">
      <div class="flex flex-row justify-between">
        <div class="">
          <label class="font-bold text-xs">{{ domain.name }}</label>
          <el-select
            filterable
            v-model="state"
            style="width: 260px; display: block"
            placeholder="Select"
          >
            <el-option label="state.name" value="state.name"> </el-option>
          </el-select>
        </div>
        <div class="ml-3 text-sm">
          <div class="font-semibold">
            Do all approvers in this function need to approve, or does it
            require a single approval to pass through?
          </div>
          <div class="flex my-3 flex-row">
            <span>
              <b-form-radio
                v-model="domain.everyOneApprove"
                :name="`approval-flow${i}`"
                value="yes"
                >Yes, everyone needs to approve.</b-form-radio
              >
            </span>
            <span class="mx-2"
              ><b-form-radio
                v-model="domain.everyOneApprove"
                :name="`approval-flow${i}`"
                value="no"
                >No, action/form needs only a single Aapproval to be
                confirmed.</b-form-radio
              ></span
            >
          </div>
        </div>
      </div>
      <approval-box :approvalBox="domain.approvalBox" :index="i"></approval-box>
      <div class="my-3 px-3">
        <img src="./partials/arrow-down.svg" alt="" />
      </div>
    </div>
    <div
      @click="addFunctionalDomain"
      class="my-3 flex flex-row text-primary-yellow"
    >
      <img src="./partials/add.svg" alt="" />
      <span class="mx-2"> Add a Functional Domain </span>
    </div>

    <div>
      <div class="text-sm">
        Approval Flow is configured in an ascending order, i.e. Highest number
        being the last approver. Please confirm that you have arranged your
        approvers accordingly before proceeding.
      </div>
      <hr class="my-3" />

      <div class="my-4">
        <div class="text-lg font-semibold">Escalation Settings (Optional)</div>
        <div class="text-sm my-3">
          Escalate approval when approvers are unavailable or have failed to
          approve within the set time limit.
        </div>
        <div class="my-3">
          <div>
            <label class="text-sm">Time Limit</label>
            <div class="flex flex-row">
              <base-input
                type="number"
                style="width: 96px"
                width="w-24"
              ></base-input>
              <el-select
                filterable
                v-model="state"
                style="width: 108px; margin-left: 10px"
                placeholder="Hour(s)"
              >
                <el-option label="Hour" value="state.name"> </el-option>
                <el-option label="Day" value="state.name"> </el-option>
              </el-select>
            </div>
          </div>
        </div>
        <div>
          <div class="text-success text-base font-semibold">
            Sales and Marketing:
          </div>
          <div class="flex flex-row justify-between">
            <div class="my-auto flex flex-row border rounded p-2 h-16" style="width:358px">
              <b-avatar
                src="https://s3-alpha-sig.figma.com/img/080e/5e96/1f10eb911a32b0b791a3469cc3b8c5dc?Expires=1672617600&Signature=qA1IHuvuYttkbRXKjqYLt56vFGi9oYCcGuKZo9K3BNM0wrHBSjG1nN9tg6kyJmPpnz2MohM30qb2W24vnmu8UvvKPuv0-GK2OPmPVBizg1JyxzhrYzLqgx2i2e4bT~V35ncZRA1jkR5OT-0go4IhcSaI5zR~2uUZGIUegh7KWSIWwwXYx9FsQ9M-nlhS6Dhbur~mgl2IJ8qOf1f14QzDMGk6RxQvMFDH8OKhsocn8aV9oWDzHmsO2eN6wwQwsd7Bxq-beEqZkAd-9swiZQm2NuANj2AJJAK~N9gURoUGLgeemd2ed7355ZjKpgMVfMYjUIFMecDArhV9IKcnWnVDMw__&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4"
                size="48px"
              >
              </b-avatar>
              <div class="my-auto mx-3">
                <span class="font-semibold text-sm"
                  >Daniel Arubuike, Level 5</span
                >
                <br />
                <span class="text-sm text-muted"
                  >Digital Marketer, Sales & Marketing.</span
                >
              </div>
            </div>
            <div class="my-auto flex flex-row justify-around">
                <span class="mx-1">Escalate to:</span>
                <img class="mx-1" src="./partials/arrow.svg" alt="">
            </div>
             <div class="my-3 flex flex-row border justify-between rounded p-2 h-16" style="width:430px">
                    <base-input style="width:336px" placeholder="Enter email, name or designation..." type="text"></base-input> <base-button text="Add" background="white" color="text-primary-yellow"></base-button>
                </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ApprovalBox from "./ApprovalBox.vue";
export default {
  components: {
    ApprovalBox,
  },
  data() {
    return {
      added: true,
      functionalDomain: [
        {
          name: "Next Functional Domain",
          approvalBox: [
            {
              name: "",
              added: true,
            },
          ],
          everyOneApprove: "yes",
        },
        {
          name: "Next Functional Domain",
          approvalBox: [
            {
              name: "",
              added: false,
            },
          ],
          everyOneApprove: "no",
        },
      ],

      everyOneApprove: "yes",
      isChecked: false,
    };
  },
  methods: {
    addFunctionalDomain() {
      this.functionalDomain.push({
        name: "Next Functional Domain",
        approvalBox: [
          {
            name: "",
            added: false,
          },
        ],
        everyOneApprove: "yes",
      });
    },

    selected(checked) {
      console.log(checked.target);
    },
  },
};
</script>

<style scoped>
.job-level {
  background: #eeeeee;
  color: #878e99;
  border-style: outset;
  padding: 8px;
  height: 34px;
  width: 125px;
}

.job-level.checked {
  background: #fff;
  color: #fcc210;
  border-style: outset;
  padding: 8px;
  height: 34px;
  width: 125px;
  box-shadow: 0px 0px 10px 2px rgba(45, 49, 66, 0.06);
}
</style>